<adapt-toolbar-content alignment="right">
    <button [adaptButtonIcon]="hasCollapsed ? 'expandBorderless' : 'collapseBorderless'"
            (click)="hasCollapsed ? expandAll() : collapseAll()">
        {{ hasCollapsed ? "Expand all" : "Collapse all" }}
    </button>
</adapt-toolbar-content>

<ng-template #workflowUnlock
             let-view>
    <!-- hack to set view to initialised when this renders -->
    <!-- if on an object will be truthy, and the function will be executed -->
    @if ({ _: viewInitialised(view.key) }) {
        This feature has not been enabled yet.
        @if (view.workflow) {
            We recommend completing the
            <strong>
                <adapt-link-workflow [workflow]="view.workflow"></adapt-link-workflow>
            </strong>
            pathway, which will guide you through using this feature, and enable it for you.
        }
    }
</ng-template>

<div class="d-flex flex-column gap-4">
    @if (hasGoalsOrObjectives) {
        <div class="section-large">
            <h2 class="d-print-none"
                (click)="CollapseState[DisplayGroupKey.GoalsObjectivesView] = !CollapseState[DisplayGroupKey.GoalsObjectivesView]">
                Goals &amp; objectives
                @if (!isPrinting) {
                    <i
                       class="ms-auto fal {{ CollapseState[DisplayGroupKey.GoalsObjectivesView] ? 'fa-chevron-down' : 'fa-chevron-up' }}"></i>
                }
            </h2>
            <div [collapse]="CollapseState[DisplayGroupKey.GoalsObjectivesView]"
                 [isAnimated]="true"
                 class="section-body">
                <div class="d-flex flex-column gap-4 gap-lg-5 section-body-content">
                    <!-- @if doesn't support the 'as' syntax! -->
                    @if (views[DisplayViewKey.ObjectivesView]; as view) {
                        @if (view.workflowAllowedByAccount) {
                            <adapt-styled-dashboard-element [name]="view.text"
                                                            [isCollapsible]="!isPrinting"
                                                            [(collapsed)]="CollapseState[view.key]"
                                                            [iconClass]="view.icon"
                                                            [url]="view.hasPermission && !isPrinting ? (view.route | async) : undefined"
                                                            [linkText]="view.routeText"
                                                            [background]="!view.hasPermission"
                                                            [contentCard]="!view.hasPermission"
                                                            [class.section-objectives]="view.hasPermission">
                                @if (view.hasPermission) {
                                    <div class="split-entry">
                                        <adapt-org-objectives-dashboard-element name="Annual objectives"
                                                                                class="avoid-page-break-inside"
                                                                                [objectiveType]="ObjectiveType.Annual"
                                                                                (initialised)="viewInitialised(view.key)"></adapt-org-objectives-dashboard-element>
                                        <adapt-org-objectives-dashboard-element name="Quarterly objectives"
                                                                                class="avoid-page-break-inside"
                                                                                [objectiveType]="ObjectiveType.Quarterly"
                                                                                (initialised)="viewInitialised(view.key)"></adapt-org-objectives-dashboard-element>
                                    </div>
                                } @else {
                                    <ng-container *ngTemplateOutlet="workflowUnlock; context: { $implicit: view }"></ng-container>
                                }
                            </adapt-styled-dashboard-element>
                        }
                    }
                    @if (views[DisplayViewKey.StrategyGoalsView]; as view) {
                        @if (view.workflowAllowedByAccount) {
                            <adapt-styled-dashboard-element class="avoid-page-break-inside"
                                                            [name]="view.text"
                                                            [isCollapsible]="!isPrinting"
                                                            [(collapsed)]="CollapseState[view.key]"
                                                            [iconClass]="view.icon"
                                                            [url]="view.hasPermission && !isPrinting ? (view.route | async) : undefined"
                                                            [linkText]="view.routeText"
                                                            [contentCard]="!view.hasPermission || !hasGoals">
                                @if (view.hasPermission) {
                                    <adapt-strategic-goals [isEditing]="false"
                                                           [updateZoneExpandQueryParams]="false"
                                                           (hasDefinedGoals)="hasGoals = $event"
                                                           [expandGoals]="true"
                                                           (initialised)="viewInitialised(view.key)"></adapt-strategic-goals>
                                } @else {
                                    <ng-container *ngTemplateOutlet="workflowUnlock; context: { $implicit: view }"></ng-container>
                                }
                            </adapt-styled-dashboard-element>
                        }
                    }
                </div>
            </div>
        </div>
    }

    <div class="section-large avoid-page-break-inside">
        <h2 class="d-print-none"
            (click)="CollapseState[DisplayGroupKey.FoundationsView] = !CollapseState[DisplayGroupKey.FoundationsView]">
            Foundations
            @if (!isPrinting) {
                <i class="ms-auto fal {{ CollapseState[DisplayGroupKey.FoundationsView] ? 'fa-chevron-down' : 'fa-chevron-up' }}"></i>
            }
        </h2>
        <div [collapse]="CollapseState[DisplayGroupKey.FoundationsView]"
             [isAnimated]="true"
             class="section-body">
            <div class="d-flex flex-column gap-4 gap-lg-5 section-body-content">
                @if (views[DisplayViewKey.StrategicAnchorsView]; as view) {
                    @if (view.workflowAllowedByAccount) {
                        <adapt-styled-dashboard-element class="avoid-page-break-inside"
                                                        [name]="view.text"
                                                        [isCollapsible]="!isPrinting"
                                                        [(collapsed)]="CollapseState[view.key]"
                                                        [iconClass]="view.icon"
                                                        [url]="view.hasPermission && !isPrinting ? (view.route | async) : undefined"
                                                        [linkText]="view.routeText"
                                                        [contentCard]="!view.hasPermission || anchors.length === 0">
                            @if (view.hasPermission) {
                                <adapt-strategic-anchors [anchors]="anchors"></adapt-strategic-anchors>
                            } @else {
                                <ng-container *ngTemplateOutlet="workflowUnlock; context: { $implicit: view }"></ng-container>
                            }
                        </adapt-styled-dashboard-element>
                    }
                }

                <div class="split-entry">
                    @if (views[DisplayViewKey.VisionView]; as view) {
                        @if (view.workflowAllowedByAccount) {
                            <adapt-styled-dashboard-element class="avoid-page-break-inside"
                                                            [name]="view.text"
                                                            [isCollapsible]="!isPrinting"
                                                            [(collapsed)]="CollapseState[view.key]"
                                                            [iconClass]="view.icon"
                                                            [url]="view.hasPermission && !isPrinting ? (view.route | async) : undefined"
                                                            [linkText]="view.routeText"
                                                            [contentCard]="true">
                                @if (view.hasPermission) {
                                    <adapt-see-more [maxHeight]="350"
                                                    gradient>
                                        @if (vision?.vision; as visionContent) {
                                            <div [froalaView]="visionContent"></div>
                                        } @else {
                                            No vision has been defined.
                                        }
                                    </adapt-see-more>
                                } @else {
                                    <ng-container *ngTemplateOutlet="workflowUnlock; context: { $implicit: view }"></ng-container>
                                }
                            </adapt-styled-dashboard-element>
                        }
                    }

                    @if (views[DisplayViewKey.BullseyeView]; as view) {
                        @if (view.workflowAllowedByAccount) {
                            <adapt-styled-dashboard-element class="avoid-page-break-inside"
                                                            [name]="view.text"
                                                            [isCollapsible]="!isPrinting"
                                                            [(collapsed)]="CollapseState[view.key]"
                                                            [iconClass]="view.icon"
                                                            [url]="bullseyeRoute | async"
                                                            [linkText]="view.routeText"
                                                            [contentCard]="true">
                                @if (view.hasPermission || (views[DisplayViewKey.VisionView].hasPermission && !isAlto)) {
                                    @if (view.hasPermission ? bullseye?.statement : vision?.bullseye; as bullseyeContent) {
                                        <div [froalaView]="bullseyeContent"></div>
                                    } @else {
                                        No bullseye has been defined.
                                    }
                                } @else {
                                    <ng-container *ngTemplateOutlet="workflowUnlock; context: { $implicit: view }"></ng-container>
                                }
                            </adapt-styled-dashboard-element>
                        }
                    }
                </div>

                <div class="split-entry">
                    @if (views[DisplayViewKey.PurposeView]; as view) {
                        @if (view.workflowAllowedByAccount) {
                            <adapt-styled-dashboard-element class="avoid-page-break-inside"
                                                            [name]="view.text"
                                                            [isCollapsible]="!isPrinting"
                                                            [(collapsed)]="CollapseState[view.key]"
                                                            [iconClass]="view.icon"
                                                            [url]="view.hasPermission && !isPrinting ? (view.route | async) : undefined"
                                                            [linkText]="view.routeText"
                                                            [contentCard]="true">
                                @if (view.hasPermission) {
                                    @if (purpose?.content; as purposeContent) {
                                        <div [froalaView]="purposeContent"></div>
                                    } @else {
                                        No purpose has been defined.
                                    }
                                } @else {
                                    <ng-container *ngTemplateOutlet="workflowUnlock; context: { $implicit: view }"></ng-container>
                                }
                            </adapt-styled-dashboard-element>
                        }
                    }

                    @if (views[DisplayViewKey.ValuesView]; as view) {
                        @if (view.workflowAllowedByAccount) {
                            <adapt-styled-dashboard-element class="avoid-page-break-inside"
                                                            [name]="view.text"
                                                            [isCollapsible]="!isPrinting"
                                                            [(collapsed)]="CollapseState[view.key]"
                                                            [iconClass]="view.icon"
                                                            [url]="view.hasPermission && !isPrinting ? (view.route | async) : undefined"
                                                            [linkText]="view.routeText"
                                                            [contentCard]="true">
                                @if (view.hasPermission) {
                                    <adapt-values-constitution-list-view [showCTA]="false"
                                                                         (initialised)="viewInitialised(view.key)"></adapt-values-constitution-list-view>
                                } @else {
                                    <ng-container *ngTemplateOutlet="workflowUnlock; context: { $implicit: view }"></ng-container>
                                }
                            </adapt-styled-dashboard-element>
                        }
                    }
                </div>
            </div>
        </div>
    </div>
</div>
